import { configureStore } from '@reduxjs/toolkit'
import websiteSlice from './slice/websiteSlice'

export default configureStore({
  reducer: {
    website: websiteSlice
  },
})